import { _$t } from "@/utils/i18n";

export class ValidationConfig {
  patterns: { [key: string]: string } = {};
  patternNames: { [key: string]: string } = {};
  messages: { [key: string]: string } = {};

  constructor() {
    (this.patterns = {
      // 英字
      alpha: "^[a-zA-Z]+$",
      // 英数字
      alphanum: "^[a-zA-Z0-9]+$",
      // 英数字ハイフン
      alphanumhyphen: "^[a-zA-Z0-9\\-]+$",
      // 英数字ハイフン(先頭・末尾のハイフンは不可)
      sitekeyalphanumhyphen: "^[a-z0-9]+[-a-z0-9]+[a-z0-9]$",
      // 英数字、半角記号（半角スペース含む）
      alphanumchar: "^[a-zA-Z0-9 !-\\/:-@\\[-`{-~¥]+$",
      // 数字
      number: "^[0-9]*$",
      // ひらがな（ー含む）
      // ゞは、含まない。
      hiragana: "^[ぁ-んー　]+$",
      //カタカナ（ー含む）
      //  ヵヶは、含まない。
      katakana: "^[ァ-ヴー　]+$",
      //郵便番号
      //  対応形式「XXX-XXXX」
      zipCode: "^\\d{3}-\\d{4}$",
      //携帯電話番号
      //  １番上：対応形式「XXX-XXXX-XXXX、XXXXXXXXXXX（11桁）」
      //  ２番目：対応形式「0X0-XXXX-XXXX」
      //mobileNumber: /^\d{3}-\d{4}-\d{4}$|^\d{11}$/
      mobileNumber: "^0\\d{1}0-\\d{4}-\\d{4}$",
      //電話番号
      //  １番上：対応形式「-」なしの6～9桁、「-」ありの時は12桁以下であるか否か
      //  ２番目：対応形式「(1～4桁)-XXXX、(2～5桁)-(1～4桁)-(3～4桁)」
      //phoneNumber: /^[0-9-]{6,9}$|^[0-9-]{12}$/,
      phoneNumber: "^\\d{1,4}-\\d{4}$|^\\d{2,5}-\\d{1,4}-\\d{3,4}$",
      //FAX番号
      //  ２番目：対応形式「(1～4桁)-XXXX、(2～5桁)-(1～4桁)-(3～4桁)」
      faxNumber: "^\\d{1,4}-\\d{4}$|^\\d{2,5}-\\d{1,4}-\\d{3,4}$",
      //西暦
      //  yyyy/mm/dd形式。
      //  閏年も対応。
      //date: /^(?:\d{4}\/(?:(?:0?[1-9]|1[0-2])\/(?:0?[1-9]|1[0-9]|2[0-8])|(?:0?[13-9]|1[0-2])\/(?:29|30)|(?:0?[13578]|1[02])\/31)|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:[02468][048]|[13579][26])00)\/0?2\/29)$/
      date: "^(?:\\d{4}\\/(?:(?:0[1-9]|1[0-2])\\/(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])\\/(?:29|30)|(?:0[13578]|1[02])\\/31)|(?:\\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:[02468][048]|[13579][26])00)\\/02\\/29)$",
      //西暦
      //  yyyy/mm/dd hh:mm形式。
      //  閏年も対応。
      //dateTime: /^(?:\d{4}\/(?:(?:0?[1-9]|1[0-2])\/(?:0?[1-9]|1[0-9]|2[0-8])|(?:0?[13-9]|1[0-2])\/(?:29|30)|(?:0?[13578]|1[02])\/31)|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:[02468][048]|[13579][26])00)\/0?2\/29) ([01]?[0-9]|2[0-3]):([0-5][0-9])$/
      dateTime:
        "^(?:\\d{4}\\/(?:(?:0[1-9]|1[0-2])\\/(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])\\/(?:29|30)|(?:0[13578]|1[02])\\/31)|(?:\\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:[02468][048]|[13579][26])00)\\/02\\/29) ([01]?[0-9]|2[0-3]):([0-5][0-9])$",
      //時刻
      //  XX:XX
      time: "^([01]?[0-9]|2[0-3]):([0-5][0-9])$",
      //全角
      //  全角スペース含む。
      zenkaku: "^[^ -~｡-ﾟ]+$",
      //半角
      //  半角スペース含む。
      //  半角カタカナ含む。『ｱ』
      hankaku: "^[ -~｡-ﾟ]+$",
      //半角記号
      //  !"//$%&'()*+,-./
      //  :;<=>?@
      //  [\]^_`
      //  {|}~
      //  半角スペース含む。
      //  半角カタカナ含まない。『ｱ』
      char: "^[ !-\\/:-@\\[-`{-~¥]+$",
      //JIS X 0208
      //  漢字(JIS第一水準、JIS第二水準)
      //    [\x{4E00}-\x{9FA0}]の範囲。[一-龠]
      //  ひらがな
      //  カタカナ
      //  記号
      //  ギリシャ文字
      //  キリル文字
      //  罫線素片
      //  全角英数字
      //
      //  U+3005:々（漢字の踊り字）
      //  U+3007:〇（漢数字のゼロ）
      //  U+303B:〻（漢字の踊り字） これは、含まない。
      //  括弧付き漢字㈠、丸付き漢字㊀は、含まない。
      //  全角スペース含む。
      jisx0208:
        "^([一-龠]|[０-９]|[Ａ-Ｚａ-ｚ]|[ぁ-ん]|[ァ-ヶ]|[Α-Ω]|[α-ω]|[А-ЯЁ]|[а-яё]|[─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂]|[　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇－ー―‐／＼〜‖｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋−±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄¢£％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓∈∋⊆⊇⊂⊃∪∩∧∨¬⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯])+$",
      //JIS X 0208、と、改行
      jisx0208Break:
        "^([\\r\\n|\\r|\\n]|[一-龠]|[０-９]|[Ａ-Ｚａ-ｚ]|[ぁ-ん]|[ァ-ヶ]|[Α-Ω]|[α-ω]|[А-ЯЁ]|[а-яё]|[─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂]|[　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇－ー―‐／＼〜‖｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋−±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄¢£％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓∈∋⊆⊇⊂⊃∪∩∧∨¬⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯])+$",
      //JIS X 0208、と、半角英数字記号空白
      jisx0208anc:
        "^([a-zA-Z0-9]|[ !-\\/:-@\\[-`{-~¥]|[一-龠]|[０-９]|[Ａ-Ｚａ-ｚ]|[ぁ-ん]|[ァ-ヶ]|[Α-Ω]|[α-ω]|[А-ЯЁ]|[а-яё]|[─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂]|[　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇－ー―‐／＼〜‖｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋−±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄¢£％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓∈∋⊆⊇⊂⊃∪∩∧∨¬⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯])+$",
      //JIS X 0208、と、半角英数字記号空白、と、改行
      jisx0208ancBreak:
        "^([\\r\\n|\\r|\\n]|[a-zA-Z0-9]|[ !-\\/:-@\\[-`{-~¥]|[一-龠]|[０-９]|[Ａ-Ｚａ-ｚ]|[ぁ-ん]|[ァ-ヶ]|[Α-Ω]|[α-ω]|[А-ЯЁ]|[а-яё]|[─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂]|[　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇－ー―‐／＼〜‖｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋−±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄¢£％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓∈∋⊆⊇⊂⊃∪∩∧∨¬⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯～])+$",

      //漢字 unicode 全部
      //※使用しない。
      //  3005 々 （漢字の踊り字）
      //  3007 〇 （漢数字のゼロ）
      //  303B 〻 （漢字の踊り字）
      //  3400..9FFF CJK統合漢字拡張A（＋易経の四十六卦）＋CJK統合漢字
      //  F900..FAFF CJK互換漢字
      //  20000..2FFFF CJK統合漢字拡張B〜D＋CJK互換漢字追加（＋念のため）
      //      U+2000B[ ](『丈』の右上に点)も、カバー。『𠀋』
      //  括弧付き漢字㈠、丸付き漢字㊀は、含む。。
      //kanji: /(?:[々〇〻\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD87F][\uDC00-\uDFFF])/

      //----------------------------
      //ファイル名
      //filename
      //タグ
      //
      //日付、相関チェック、未来チェック
      //

      //ドメインのフォーマット
      //  先頭と末尾の文字は英数字
      //  先頭と末尾以外の文字は英数字とハイフン許可
      //  ラベル全体の長さは3文字以上63文字以下
      //  先頭と末尾の文字は英数字
      domainFormat: "([A-Za-z0-9][A-Za-z0-9\\-]{1,61}[A-Za-z0-9]\\.)+[A-Za-z]+",

      //アイモバイル管理ID
      //SFAID 10桁 - KYSID 6桁
      //0000000000-000000
      imMngId: "^\\d{10}-\\d{6}$",

      // メールアドレス
      email:
        "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$",

      // カラーコード
      colorCode: "^#[0-9A-Fa-f]{6}$",
    }),
    // パターンチェック名
    // 入力チェックパターンを追加した場合は、ここに追加。
    (this.patternNames = {
      number: _$t("msg_validate_pattern_number"),
      email: _$t("msg_validate_pattern_email"),
      url: _$t("msg_validate_pattern_url"),
      digits: _$t("msg_validate_pattern_digits"),
      alpha: _$t("msg_validate_pattern_alpha"),
      alphanum: _$t("msg_validate_pattern_alphanum"),
      alphanumhyphen: _$t("msg_validate_pattern_alphanumhyphen"),
      sitekeyalphanumhyphen: _$t(
        "msg_validate_pattern_sitekeyalphanumhyphen"
      ),
      alphanumchar: _$t("msg_validate_pattern_alphanumchar"),
      hiragana: _$t("msg_validate_pattern_hiragana"),
      katakana: _$t("msg_validate_pattern_katakana"),
      zipCode: _$t("msg_validate_pattern_zipCode"),
      mobileNumber: _$t("msg_validate_pattern_mobileNumber"),
      phoneNumber: _$t("msg_validate_pattern_phoneNumber"),
      faxNumber: _$t("msg_validate_pattern_faxNumber"),
      date: _$t("msg_validate_pattern_date"),
      dateTime: _$t("msg_validate_pattern_dateTime"),
      time: _$t("msg_validate_pattern_time"),
      zenkaku: _$t("msg_validate_pattern_zenkaku"),
      hankaku: _$t("msg_validate_pattern_hankaku"),
      char: _$t("msg_validate_pattern_char"),
      jisx0208: _$t("msg_validate_pattern_jisx0208"),
      jisx0208Break: _$t("msg_validate_pattern_jisx0208Break"),
      jisx0208anc: _$t("msg_validate_pattern_jisx0208anc"),
      jisx0208ancBreak: _$t("msg_validate_pattern_jisx0208ancBreak"),
      domainFormat: _$t("msg_validate_pattern_domainFormat"),
      imMngId: _$t("msg_validate_pattern_imMngId"),
      colorCode: _$t("msg_validate_pattern_colorCode"),
    }),
    // 入力チェックに対するメッセージ
    (this.messages = {
      required: _$t("msg_error_required"),
      acceptance: _$t("msg_error_acceptance"),
      min: _$t("msg_error_min"),
      max: _$t("msg_error_max"),
      range: _$t("msg_error_range"),
      length: _$t("msg_error_length"),
      minLength: _$t("msg_error_minLength"),
      maxLength: _$t("msg_error_maxLength"),
      rangeLength: _$t("msg_error_rangeLength"),
      oneOf: _$t("msg_error_oneOf"),
      equalTo: _$t("msg_error_equalTo"),
      pattern: _$t("msg_error_pattern"),
      dateAfter: _$t("msg_error_dateAfter"),
      dateAfterEqual: _$t("msg_error_dateAfterEqual"),
      datePeriod: _$t("msg_error_datePeriod"),
      dateAndTimeAfter: _$t("msg_error_dateAfter"),
      requiredIf: _$t("msg_error_requiredIf"),
      noHalfSpace: _$t("msg_error_noHalfSpace"),
      noFullSpace: _$t("msg_error_noFullSpace"),
      noFullHyphen: _$t("msg_error_noFullHyphen"),
      ngword: _$t("msg_error_ngword"),
      minimum: _$t("msg_error_min"),
      maximum: _$t("msg_error_max"),
    });
  }
}
